import { render, staticRenderFns } from "./page-dialog.vue?vue&type=template&id=b8cf5210&scoped=true"
import script from "./page-dialog.vue?vue&type=script&lang=js"
export * from "./page-dialog.vue?vue&type=script&lang=js"
import style0 from "./page-dialog.vue?vue&type=style&index=0&id=b8cf5210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cf5210",
  null
  
)

export default component.exports